import UserProfilePage from './Components/UserProfilePage';

window.UserProfile = {};
window.UserProfile.load = function(containerId) {
    var userProfilePage = new UserProfilePage;
    userProfilePage.load(containerId);
}
